import { HandleMutationResult } from 'modules/core/lib/handleMutation'

import { withFlash } from './withFlash'

type DraftMutationFn = (variables: {
  id: string
  resourceType: string
}) => HandleMutationResult<unknown>

export const createDraftAction = (draftFn: DraftMutationFn, resourceType: string) => {
  return (id: string) => withFlash(draftFn({ id, resourceType }))
}
